import React from 'react';

// أيقونات SVG بخط موحّد (stroke=currentColor) — بنفس أسلوب الأيقونات
// المستخدمة في صف الإجراءات السريعة وقسم الخدمات بصفحة المحفظة (Wallet.js)،
// لتوحيد الشكل بدل الإيموجي العادي في القائمة الجانبية والشريط السفلي.

const base = { fill:'none', stroke:'currentColor', strokeWidth:'2', strokeLinecap:'round', strokeLinejoin:'round' };

export function IconHome({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 11.5 12 4l9 7.5"/>
      <path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9"/>
    </svg>
  );
}

export function IconWallet({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"/>
      <path d="M16 12h3v3h-3a1.5 1.5 0 0 1 0-3Z" fill="currentColor" opacity="0.15"/>
      <circle cx="16.3" cy="13.5" r="0.9" fill="currentColor" stroke="none"/>
    </svg>
  );
}

// نفس رسم بطاقة "شراء كروت" الموجود بالضبط في Wallet.js — لضمان تطابق الشكل حرفياً
export function IconCard({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="5" width="22" height="14" rx="3" stroke="currentColor" strokeWidth="1.8"/>
      <rect x="1" y="9" width="22" height="3" fill="currentColor" opacity="0.3"/>
      <circle cx="17" cy="14.5" r="1" fill="currentColor"/>
      <path d="M14.8 14.5 a2.8 2.8 0 0 1 4.4 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" fill="none"/>
      <path d="M13 14.5 a5 5 0 0 1 8 0" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.5"/>
      <rect x="4" y="14" width="5" height="1.5" rx="0.75" fill="currentColor" opacity="0.5"/>
    </svg>
  );
}

// نفس رسم "إضافة رصيد" الموجود بالضبط في Wallet.js
export function IconAddBalance({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
    </svg>
  );
}

export function IconStar({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 2.5l2.9 6.2 6.6.8-4.9 4.6 1.3 6.7L12 17.6l-5.9 3.2 1.3-6.7-4.9-4.6 6.6-.8L12 2.5Z"/>
    </svg>
  );
}

export function IconHistory({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M5 6h14v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6Z"/>
      <path d="M8 3h8v3H8z"/>
      <line x1="8" y1="11" x2="16" y2="11"/>
      <line x1="8" y1="15" x2="16" y2="15"/>
      <line x1="8" y1="19" x2="12" y2="19"/>
    </svg>
  );
}

export function IconStore({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 9V6.5a1 1 0 0 1 .3-.7l1.6-1.6a1 1 0 0 1 .7-.3h10.8a1 1 0 0 1 .7.3l1.6 1.6a1 1 0 0 1 .3.7V9"/>
      <path d="M4 9a2.2 2.2 0 0 0 4.4.2A2.2 2.2 0 0 0 12 9a2.2 2.2 0 0 0 4.4.2A2.2 2.2 0 0 0 20 9"/>
      <path d="M5 9.5V19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5"/>
      <path d="M9.5 20v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5"/>
    </svg>
  );
}

export function IconUser({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="8" r="3.6"/>
      <path d="M4.5 20.2a7.5 7.5 0 0 1 15 0"/>
    </svg>
  );
}

export function IconGamepad({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M7 8h10a4.5 4.5 0 0 1 4.4 5.4l-.6 3a2.3 2.3 0 0 1-4-1L16 14H8l-.8 1.4a2.3 2.3 0 0 1-4 1l-.6-3A4.5 4.5 0 0 1 7 8Z"/>
      <line x1="8" y1="11" x2="8" y2="13.4"/>
      <line x1="6.8" y1="12.2" x2="9.2" y2="12.2"/>
      <circle cx="15.5" cy="10.8" r="0.6" fill="currentColor" stroke="none"/>
      <circle cx="17.3" cy="12.5" r="0.6" fill="currentColor" stroke="none"/>
    </svg>
  );
}

export function IconTicket({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.2a1.8 1.8 0 0 0 0 3.6V15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.2a1.8 1.8 0 0 0 0-3.6V9Z"/>
      <line x1="12" y1="7.5" x2="12" y2="16.5" strokeDasharray="2 2"/>
    </svg>
  );
}

export function IconSearch({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="10.5" cy="10.5" r="6.5"/>
      <line x1="15.3" y1="15.3" x2="20.5" y2="20.5"/>
    </svg>
  );
}

export function IconBox({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3.5 8 12 3.5 20.5 8 12 12.5 3.5 8Z"/>
      <path d="M3.5 8v9L12 21.5"/>
      <path d="M20.5 8v9L12 21.5"/>
      <line x1="12" y1="12.5" x2="12" y2="21.5"/>
    </svg>
  );
}

export function IconInbox({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 12 6.5 5.5a1.5 1.5 0 0 1 1.4-1h8.2a1.5 1.5 0 0 1 1.4 1L20 12"/>
      <path d="M4 12h4.8l1 2h4.4l1-2H20v6a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18v-6Z"/>
    </svg>
  );
}

export function IconClock({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="9"/>
      <polyline points="12 7 12 12 15.5 14"/>
    </svg>
  );
}

export function IconSignal({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="5" y1="19" x2="5" y2="15"/>
      <line x1="10" y1="19" x2="10" y2="11"/>
      <line x1="15" y1="19" x2="15" y2="7"/>
      <line x1="20" y1="19" x2="20" y2="3"/>
    </svg>
  );
}

export function IconUsers({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="9" cy="8" r="3.2"/>
      <path d="M3 20a6 6 0 0 1 12 0"/>
      <circle cx="17" cy="9" r="2.6"/>
      <path d="M15 20a5 5 0 0 1 6.5-4.8"/>
    </svg>
  );
}

export function IconTrophy({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M7 4h10v5a5 5 0 0 1-10 0V4Z"/>
      <path d="M7 5.5H4a2 2 0 0 0 0 4h1.3M17 5.5h3a2 2 0 0 1 0 4h-1.3"/>
      <line x1="12" y1="14" x2="12" y2="18"/>
      <path d="M8.5 21h7l-1-3h-5l-1 3Z"/>
    </svg>
  );
}

export function IconCheckCircle({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="9"/>
      <polyline points="8 12.5 10.8 15.3 16 9.3"/>
    </svg>
  );
}

export function IconChat({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 5.5h16v10.5a1 1 0 0 1-1 1H9l-4 3.5V17H4a1 1 0 0 1-1-1V6.5a1 1 0 0 1 1-1Z" transform="translate(0.5 -0.5)"/>
      <line x1="7.5" y1="9.5" x2="16.5" y2="9.5"/>
      <line x1="7.5" y1="13" x2="13.5" y2="13"/>
    </svg>
  );
}

export function IconChart({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="5" y1="20" x2="5" y2="12"/>
      <line x1="11" y1="20" x2="11" y2="7"/>
      <line x1="17" y1="20" x2="17" y2="14"/>
      <line x1="3" y1="20" x2="21" y2="20"/>
    </svg>
  );
}

export function IconMoney({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="2.5" y="6" width="19" height="12" rx="2"/>
      <circle cx="12" cy="12" r="2.6"/>
      <line x1="5.5" y1="9" x2="5.5" y2="9.01"/>
      <line x1="18.5" y1="15" x2="18.5" y2="15.01"/>
    </svg>
  );
}

export function IconUserX({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="10" cy="8" r="3.6"/>
      <path d="M3.5 20.2a6.5 6.5 0 0 1 13 0"/>
      <line x1="16.5" y1="7.5" x2="21" y2="12"/>
      <line x1="21" y1="7.5" x2="16.5" y2="12"/>
    </svg>
  );
}

export function IconShield({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 3 19 6v5.5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z"/>
      <polyline points="9 12 11 14 15 9.5"/>
    </svg>
  );
}

export function IconMegaphone({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 10v4a1 1 0 0 0 1 1h2l1.5 5h2l-1-5h1l10 4V6l-10 4H4a1 1 0 0 0-1 1Z"/>
      <path d="M19.5 9.5a3.5 3.5 0 0 1 0 5"/>
    </svg>
  );
}

export function IconBank({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <polygon points="12 3 21 8 3 8"/>
      <line x1="5" y1="10.5" x2="5" y2="17"/>
      <line x1="9.5" y1="10.5" x2="9.5" y2="17"/>
      <line x1="14.5" y1="10.5" x2="14.5" y2="17"/>
      <line x1="19" y1="10.5" x2="19" y2="17"/>
      <line x1="3" y1="20" x2="21" y2="20"/>
    </svg>
  );
}

export function IconPalette({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 3a9 8 0 1 0 0 16c1.2 0 1.7-.7 1.7-1.5 0-.4-.2-.8-.4-1.1-.3-.4-.5-.7-.5-1.2 0-.8.7-1.5 1.5-1.5H16a4.5 4.5 0 0 0 4.5-4.5C20.5 5.9 16.7 3 12 3Z"/>
      <circle cx="7.5" cy="10.5" r="1" fill="currentColor" stroke="none"/>
      <circle cx="10" cy="7" r="1" fill="currentColor" stroke="none"/>
      <circle cx="14.5" cy="7.5" r="1" fill="currentColor" stroke="none"/>
      <circle cx="8" cy="14.5" r="1" fill="currentColor" stroke="none"/>
    </svg>
  );
}

export function IconWrench({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M14.5 6.5a4 4 0 0 1-5.1 5.1L4 17l3 3 5.4-5.4a4 4 0 0 1 5.1-5.1l-2.6 2.6-2-.5-.5-2 2.1-2.1Z"/>
    </svg>
  );
}

export function IconMoon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11Z"/>
    </svg>
  );
}

export function IconSun({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="4.5"/>
      <line x1="12" y1="2.5" x2="12" y2="5"/>
      <line x1="12" y1="19" x2="12" y2="21.5"/>
      <line x1="4.2" y1="4.2" x2="6" y2="6"/>
      <line x1="18" y1="18" x2="19.8" y2="19.8"/>
      <line x1="2.5" y1="12" x2="5" y2="12"/>
      <line x1="19" y1="12" x2="21.5" y2="12"/>
      <line x1="4.2" y1="19.8" x2="6" y2="18"/>
      <line x1="18" y1="6" x2="19.8" y2="4.2"/>
    </svg>
  );
}

export function IconLogout({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M13 4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6"/>
      <line x1="21" y1="12" x2="10" y2="12"/>
      <polyline points="17 8 21 12 17 16"/>
    </svg>
  );
}

export function IconMenu({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="4" y1="7" x2="20" y2="7"/>
      <line x1="4" y1="12" x2="20" y2="12"/>
      <line x1="4" y1="17" x2="20" y2="17"/>
    </svg>
  );
}

// أيقونات أنواع العمليات (تُستخدم بسجل العمليات) — بنفس أسلوب الملف بدل الإيموجي
export function IconArrowDownCircle({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="9"/>
      <line x1="12" y1="7.5" x2="12" y2="15.5"/>
      <polyline points="8.5 12 12 15.5 15.5 12"/>
    </svg>
  );
}

export function IconCart({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 4h2l2.5 11.5a1.5 1.5 0 0 0 1.5 1.2h7a1.5 1.5 0 0 0 1.45-1.1L20 8.5H6.2"/>
      <circle cx="10" cy="19.5" r="1.3" fill="currentColor" stroke="none"/>
      <circle cx="17" cy="19.5" r="1.3" fill="currentColor" stroke="none"/>
    </svg>
  );
}

export function IconOutbox({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 12h4.8l1 2h4.4l1-2H20v6a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18v-6Z"/>
      <path d="M8 8 12 4l4 4"/>
      <line x1="12" y1="4" x2="12" y2="13"/>
    </svg>
  );
}

export function IconEdit({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 20h4l10.5-10.5a2 2 0 0 0 0-2.8l-1.2-1.2a2 2 0 0 0-2.8 0L4 16v4Z"/>
      <line x1="13.5" y1="6.5" x2="17.5" y2="10.5"/>
    </svg>
  );
}

export function IconRefresh({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 12a8 8 0 0 1 14-5.2"/>
      <path d="M20 12a8 8 0 0 1-14 5.2"/>
      <polyline points="18 3 18 7 14 7"/>
      <polyline points="6 21 6 17 10 17"/>
    </svg>
  );
}

export function IconGift({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="9" width="18" height="12" rx="1"/>
      <path d="M3 9h18v4H3z" fill="currentColor" opacity="0.15"/>
      <line x1="12" y1="9" x2="12" y2="21"/>
      <path d="M12 9C9.5 9 8 7.5 8 6a2 2 0 0 1 4-.5C12.3 3.8 13 3 14.5 3A2 2 0 0 1 16 6c0 2-2.2 3-4 3Z"/>
    </svg>
  );
}

export function IconXCircle({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="10"/>
      <line x1="9" y1="9" x2="15" y2="15"/>
      <line x1="15" y1="9" x2="9" y2="15"/>
    </svg>
  );
}

export function IconClose({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="5" y1="5" x2="19" y2="19"/>
      <line x1="19" y1="5" x2="5" y2="19"/>
    </svg>
  );
}

export function IconBell({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  );
}

export function IconKey({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="7.5" cy="15.5" r="4.5"/>
      <path d="M10.8 12.2 19 4l3 3-2 2-2-2-2.2 2.2 2 2-2 2-2-2-1.8 1.8"/>
    </svg>
  );
}

export function IconCopy({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="9" y="9" width="12" height="12" rx="2"/>
      <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/>
    </svg>
  );
}

export function IconPhone({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="6" y="2" width="12" height="20" rx="2.5"/>
      <line x1="11" y1="18" x2="13" y2="18" strokeWidth="2.6"/>
    </svg>
  );
}

export function IconHash({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="5" y1="9" x2="19" y2="9"/>
      <line x1="5" y1="15" x2="19" y2="15"/>
      <line x1="10" y1="4" x2="8" y2="20"/>
      <line x1="16" y1="4" x2="14" y2="20"/>
    </svg>
  );
}

export function IconCalendar({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="5" width="18" height="16" rx="2"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
      <line x1="8" y1="3" x2="8" y2="7"/>
      <line x1="16" y1="3" x2="16" y2="7"/>
    </svg>
  );
}

export function IconImage({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none"/>
      <path d="M4 17l5-5 4 4 3-3 4 4"/>
    </svg>
  );
}

export function IconWarning({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 3 22 20H2L12 3Z"/>
      <line x1="12" y1="10" x2="12" y2="15"/>
      <circle cx="12" cy="18" r="0.6" fill="currentColor" stroke="none"/>
    </svg>
  );
}

export function IconNote({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 4h13l3 3v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z"/>
      <line x1="7" y1="9" x2="14" y2="9"/>
      <line x1="7" y1="13" x2="14" y2="13"/>
    </svg>
  );
}

export function IconInfo({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="11" x2="12" y2="16"/>
      <circle cx="12" cy="7.5" r="0.6" fill="currentColor" stroke="none"/>
    </svg>
  );
}

export function IconUnlock({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="4" y="11" width="14" height="10" rx="2"/>
      <path d="M8 11V7a4 4 0 0 1 7.6-1.8"/>
      <circle cx="11" cy="16" r="1.4" fill="currentColor" stroke="none"/>
    </svg>
  );
}

// أيقونة "قوة إشارة" متدرّجة — تُستخدم لباقات البيانات حسب حجمها (level من 1 إلى 4)
export function IconDataBars({ size = 20, level = 4 }) {
  const bars = [6, 10, 14, 18];
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {bars.map((h, i) => (
        <rect key={i} x={2 + i * 5.5} y={20 - h} width={4} height={h} rx={1}
          fill={i < level ? 'currentColor' : 'none'}
          stroke="currentColor" strokeWidth={i < level ? 0 : 1.5}
          opacity={i < level ? 1 : 0.35}/>
      ))}
    </svg>
  );
}

export function IconGlobe({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="9"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <path d="M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9Z"/>
    </svg>
  );
}

export function IconId({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="2.5" y="5" width="19" height="14" rx="2"/>
      <circle cx="8" cy="11.5" r="2.2"/>
      <path d="M4.8 16.2a3.4 3.4 0 0 1 6.4 0"/>
      <line x1="13.5" y1="9.5" x2="18.5" y2="9.5"/>
      <line x1="13.5" y1="13" x2="18.5" y2="13"/>
    </svg>
  );
}

export function IconGem({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 9 8 3h8l4 6-10 12L4 9Z"/>
      <line x1="4" y1="9" x2="20" y2="9"/>
      <line x1="9" y1="3" x2="8" y2="9"/>
      <line x1="15" y1="3" x2="16" y2="9"/>
    </svg>
  );
}
